export const TABS = {
  GENERAL: "general",
  DEPLOYMENT: "deployment",
  ANALYTICS: "analytics"
};

export const PAGE_TITLE = "Agent settings";
